module.exports = __webpack_public_path__ + "static/nick-telson-41366b6e343914230421387346db1fb9.webp";